import { randomBytes } from 'crypto-browserify';

export class Store {
    static load(key) {
        try {
            const data = localStorage.getItem(key);
            if (data !== null) {
                return JSON.parse(data);
            }
        } catch (e) {
            console.warn(e);
            this.clear();
        }
        return {};
    }
    static save(key, data) {
        if (isEmpty(data)) {
            localStorage.removeItem(key);
        } else {
            try {
                localStorage.setItem(key, JSON.stringify(data));
            } catch (e) {
                console.warn(e);
            }
        }
    }
    static clear(key) {
        localStorage.removeItem(key);
    }
}

function isEmpty(data) {
    if (data === null) {
        return true;
    }
    return Object.keys(data).length === 0;
}

const IDENTIFIER = 'identifier';
const INSTALLED = 'installed';
const DEVICE = 'device';

export class AuthStore {
    static load(name) {
        const key = `auth:${name}`;
        const data = Store.load(key);
        return new AuthStore(key, data);
    }
    static save(authStore) {
        Store.save(authStore.key, authStore.data);
    }
    static remove(authStore) {
        this.data = [];
        Store.clear(authStore.key);
    }
    constructor(key, data) {
        this.key = key;
        this.data = data;
    }
    has(name) {
        return this.data.hasOwnProperty(name);
    }
    set(name, value) {
        this.data[name] = value;
    }
    get(name) {
        return this.data[name];
    }
    remove(name) {
        delete this.data[name];
    }
    isInstall() {
        return this.has(INSTALLED);
    }
    saveInstalation(id) {
        this.set(INSTALLED, id);
        this.remove(DEVICE);
    }
    removeInstallation() {
        return this.remove(INSTALLED);
    }
    getInstallation() {
        return this.get(INSTALLED);
    }
    getIdentifier() {
        let id = this.get(IDENTIFIER);
        if (!id) {
            id = generateId();
            this.set(IDENTIFIER, id);
        }
        return id;
    }
    getDevice() {
        return this.get(DEVICE);
    }
    saveDevice(device) {
        this.set(DEVICE, device);
    }
    removeDevice() {
        return this.remove(DEVICE);
    }
}

function generateId(len = 32) {
    const bytes = randomBytes(len);
    return bytes.toString('hex');
}
